export enum FiltrosObrigacoesEnum {
	Origem = 'origem',
	Responsavel = 'responsavel',
	Aprovador = 'aprovador',
	Situacao = 'situacao',
	Tipo = 'tipo',
	Descricao = 'descricao',
	Nome = 'nome',
}
